import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { useConfigContext } from '#src/contexts/config/index.ts';
import { useIsMobile } from '#src/hooks/device/useIsMobile.ts';
import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { tabletAndAbove } from '#src/style/mediaQuery.ts';
import { theme } from '#src/style/theme.tsx';

import minus18Icon from './assets/18.svg';
import franceLogo from './assets/france.webp';

const JOUEURS_INFO_SERVICE_URL = 'https://www.joueurs-info-service.fr';

const Root = styled.a`
  isolation: isolate;
  display: flex;
  text-decoration: none;
  padding: var(--unit) var(--double-unit);
  gap: var(--unit);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: ${theme.zIndex.snackbar + 1};
  @media ${tabletAndAbove} {
    flex-direction: row;
    gap: var(--double-unit);
    padding: var(--double-unit) var(--quadruple-unit);
  }
`;

const Message = styled.p`
  font: var(--t-12);
  font-weight: 700;
  text-transform: uppercase;
  color: var(--c-white);
  text-align: center;
  line-height: 1.4;
  margin: 0;
  @media ${tabletAndAbove} {
    max-width: 800px;
    font: var(--t-16);
    line-height: 1.4;
  }
`;

const GouvernementLogoWrapper = styled.div`
  background: white;
  border-radius: var(--half-unit);
  padding: var(--half-unit) var(--unit);
  flex-grow: 0;
`;

type Props = {
  className?: string;
  mobileOnly?: boolean;
};

export const LegalWarningBanner = ({
  className,
  mobileOnly = false,
}: Props) => {
  const {
    flags: { jonumUserInfoCollection = false },
  } = useFeatureFlags();

  const {
    currentLocation: { countryCode },
  } = useConfigContext();

  const isMobile = useIsMobile();

  if (
    !jonumUserInfoCollection ||
    countryCode?.toUpperCase() !== 'FR' ||
    (!isMobile && mobileOnly)
  ) {
    return null;
  }

  return (
    <Root
      className={className}
      href={JOUEURS_INFO_SERVICE_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Message>
        Votre activité de jeu peut être dangereuse : pertes d&apos;argent,
        conflits familiaux, addiction, etc. Retrouvez nos conseils sur
        joueurs-info-service.fr (09 74 75 13 13 - appel non surtaxé)
      </Message>
      <Horizontal center gap={2}>
        <img src={minus18Icon} alt="Interdit aux moins de 18 ans" height={36} />
        <GouvernementLogoWrapper>
          <img
            src={franceLogo}
            alt="Gouvernement Français - Liberté, Égalité, Fraternité"
            height={36}
          />
        </GouvernementLogoWrapper>
      </Horizontal>
    </Root>
  );
};
